import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import { AdminGalleryCard } from "./AdminGalleryCard";
import { galleriesStore } from "../../../../stores/galleries/galleriesStore";
export const AdminGalleriesList = () => {
    const pageItems = galleriesStore.usePageItems();
    return (_jsx(Grid, { container: true, spacing: 2, children: pageItems.map(i => _jsx(Grid, { item: true, xs: 12, children: _jsx(AdminGalleryCard, { gallery: i }, void 0) }, i.id)) }, void 0));
};
//# sourceMappingURL=AdminGalleriesList.js.map